import type { Locale } from './zh_CN';

const fullYear = new Date().getFullYear();
export const zh_TW: Locale = {
  lang: 'zh_TW',
  layout: {
    home: '主頁',
    header: {
      profile: '個人中心',
      download: '下載中心',
      password: '修改密碼',
      logout: '安全登出'
    },
    footer: {
      website: '官網',
      document: '檔案',
      authorization: '授權',
      ipc: '蜀ICP备17025563号-7',
      copyright: `© 2017-${fullYear} 成都論之道科技有限責任公司`
    },
    logout: {
      title: '詢問',
      message: '確定要登出嗎?'
    },
    tabs: {
      reload: '重繪當前頁簽',
      close: '關閉當前頁簽',
      closeLeft: '關閉左側頁簽',
      closeRight: '關閉右側頁簽',
      closeOther: '關閉其他頁簽',
      closeAll: '關閉全部頁簽',
      fullscreen: '內容區域全屏',
      fullscreenExit: '退出內容全屏'
    },
    setting: {
      title: '主題風格設定',
      sideStyles: {
        dark: '暗色側欄',
        light: '亮色側欄'
      },
      headStyles: {
        light: '亮色頂欄',
        dark: '暗色頂欄',
        primary: '主色頂欄'
      },
      layoutStyles: {
        side: '左側選單佈局',
        top: '頂部選單佈局',
        mix: '混合選單佈局'
      },
      colors: {
        default: '拂曉藍',
        dust: '薄暮',
        sunset: '日暮',
        volcano: '火山',
        purple: '醬紫',
        green: '極光綠',
        geekblue: '極客藍'
      },
      darkMode: '開啟暗黑模式',
      roundedTheme: '開啟圓角主題',
      layout: '導航模式',
      sidebarLayout: '側欄雙排選單',
      fluid: '內容區域鋪滿',
      other: '其它配寘',
      more: '更多配寘',
      tab: '頁簽配寘',
      fixedHeader: '固定頂欄區域',
      fixedSidebar: '固定側欄區域',
      fixedBody: '內容區域滾動',
      logoInHeader: 'Logo置於頂欄',
      colorfulIcon: '側欄彩色圖標',
      uniqueOpened: '側欄排它展開',
      responsive: '移動端響應式',
      weakMode: '開啟色弱模式',
      showTabs: '開啟多頁簽欄',
      fixedHome: '固定主頁頁簽',
      tabInHeader: '頁簽置於頂欄',
      tabStyle: '頁簽顯示風格',
      tabStyles: {
        default: '默認',
        dot: '圓點',
        tag: '标签',
        card: '卡片'
      },
      menuItemTrigger: '混合菜單分割',
      transitionName: '路由切換動畫',
      transitions: {
        slideRight: '滑動消退',
        slideBottom: '底部消退',
        zoomIn: '放大漸變',
        zoomOut: '縮小漸變',
        fade: '淡入淡出'
      },
      reset: '重置'
    }
  },
  login: {
    title: '用戶登錄',
    username: '請輸入登入帳號',
    password: '請輸入登入密碼',
    code: '請輸入驗證碼',
    remember: '記住帳號',
    login: '登入',
    passwordType: '密碼登入',
    qrcodeType: '掃碼登入',
    refreshQrcode: '重繪二維碼'
  },
  list: {
    // 基础列表
    basic: {
      table: {
        avatar: '頭像',
        username: '用戶賬號',
        nickname: '用戶名',
        organizationName: '組織機構',
        phone: '手機號',
        email: '郵箱',
        roles: '角色',
        sexName: '性別',
        createTime: '創建時間',
        status: '狀態',
        action: '操作'
      }
    }
  },
  global: {
    btns: {
      add: '添加',
      export: '匯出',
      import: '匯入',
      edit: '編輯',
      remove: '刪除',
      search: '查詢',
      reset: '重置',
      submit: '提交',
      submitImport: '提交匯入',
      submitContinue: '提交並繼續',
      confirm: '確認',
      revoke: '撤回',
      cancel: '取消',
      close: '關閉',
      upload: '上傳',
      download: '下載',
      homePage: '首頁',
      signIn: '登錄',
      signOut: '退出',
      enabled: '啟用',
      disabled: '禁用',
      locked: '鎖定',
      resetPassword: '重設密碼',
      notification: '通知',
      batchResetPassword: '批量重設密碼',
      copy: '複製',
      assignPermissions: '分配權限',
      configuration: '配置',
      collapseAll: '折疊全部',
      expandAll: '展開全部',
      view: '查看',
      setAsPublished: '設定已發布',
      setAsUnpublished: '設定未發布',
      assignAdvisor: '分配導師',
      confirmSelection: '確認選擇',
      unpairAdvisorStudent: '解除師生配對',
      batchAdd: '批量新增'
    },

    export: {
      select: {
        range: '選擇匯出範圍',
        fields: '選擇匯出字段'
      }
    },
    placeholder: {
      select: '請選擇',
      input: '請輸入',
      selectRange: '請選擇範圍',
      university: '所屬大學',
      college: '所屬學院',
      department: '所屬系所',
      major: '所屬專業',
      teaching: '所屬教研室',
      grade: '所屬年級',
      class: '所屬班級',
      graduation: '畢業屆次',
      studentType: '學生類別',
      degreeType: '學位類別',
      thesisType: '論文類型',
      thesisTitle: '論文題目',
      studentPhone: '學生電話',
      studentEmail: '學生郵箱',
      studentName: '學生姓名',
      studentId: '學生學號',
      supervisorName: '導師姓名',
      supervisorId: '導師帳號'
    },
    tips: {
      processing: '處理中...',
      lodding: '加載中...',
      err404: '抱歉, 你訪問的頁面不存在.',
      tokenExpired: '登錄會話已過期，請重新登錄.',
      required: '不能為空，請輸入',
      remove: '刪除後數據不可恢復，是否執行？'
    },
    /** 任务状态 */
    task: {
      status: {
        pending: '待處理',
        processing: '處理中',
        completed: '已完成'
      }
    }
  }
};
